var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKoalafiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 29,
    id: "Koalafi_Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175 29",
    style: {
      enableBackground: "new 0 0 175 29"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.kl_st0{fill:#0D4066;}\n\t.kl_st1{fill:#36C6FF;}\n\t.kl_st2{fill:#3D6EDF;}\n\t.kl_st3{fill:#49E8AB;}\n\t.kl_st4{fill:#1794A5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M60.5,1.9h-5.2c-0.9,0-1.7,0.4-2.2,1.1l-8.3,10.7V1.9h-4.2c-0.9,0-1.6,0.7-1.6,1.6v25.1h5.8V16.8l8.3,10.6 c0.5,0.7,1.4,1.1,2.2,1.1h5.2L50.1,15.2L60.5,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M76.5,9.7c-5.1-2.9-11.6-1.3-14.6,3.7c-0.9,1.6-1.4,3.4-1.4,5.2c0,1.8,0.5,3.6,1.4,5.2 c3.1,5.1,9.7,6.7,14.8,3.7c1.5-0.9,2.8-2.2,3.7-3.7c1.9-3.2,1.9-7.2,0-10.4C79.4,11.9,78.1,10.7,76.5,9.7z M75.5,21.2 c-0.4,0.8-1,1.4-1.8,1.8c-0.8,0.5-1.7,0.7-2.6,0.7c-0.9,0-1.8-0.2-2.6-0.7c-2.4-1.5-3.2-4.6-1.7-7.1c0.4-0.7,1-1.3,1.7-1.7 c0.8-0.5,1.7-0.7,2.6-0.7c0.9,0,1.8,0.2,2.6,0.7C76,15.8,76.8,18.8,75.5,21.2L75.5,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M111,1.5v27h5.6V-0.1h-4C111.7-0.1,111,0.6,111,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M136.4,10.4v0.7c-0.6-0.7-1.2-1.3-2-1.8c-1.2-0.7-2.6-1-4.2-1c-1.8,0-3.5,0.5-5,1.4c-1.4,0.9-2.6,2.2-3.4,3.8 c-0.8,1.6-1.3,3.4-1.2,5.2l0,0v0l0,0c0,1.8,0.4,3.6,1.2,5.2c0.8,1.5,2,2.8,3.4,3.8c1.5,1,3.3,1.4,5,1.4c1.6,0,3-0.3,4.2-1 c0.8-0.5,1.5-1.1,2-1.8v2.3h5.3V8.9H138C137.1,8.9,136.4,9.6,136.4,10.4z M136.1,18.7L136.1,18.7c0,0.9-0.2,1.8-0.7,2.5 c-0.4,0.7-1,1.4-1.8,1.8c-0.8,0.5-1.7,0.7-2.6,0.7c-0.9,0-1.8-0.2-2.6-0.7c-1.5-0.9-2.5-2.6-2.4-4.4v0l0,0c0-1.8,0.9-3.4,2.4-4.4 c0.8-0.5,1.7-0.7,2.6-0.7c0.9,0,1.8,0.2,2.6,0.7c0.7,0.5,1.3,1.1,1.8,1.8C135.9,16.9,136.1,17.8,136.1,18.7L136.1,18.7L136.1,18.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M157.4-0.1c-1.9,0-3.5,0.4-4.8,1.1c-1.2,0.7-2.2,1.7-2.8,3c-0.6,1.3-1,2.8-0.9,4.3v0.6H147 c-0.9,0-1.6,0.7-1.6,1.6v3.2h3.5v14.8h5.6V13.7h6.3V8.9h-6.3V8.2c0-1.1,0.3-1.9,0.9-2.5c0.6-0.5,1.5-0.8,2.5-0.8 c0.5,0,1.1,0.1,1.6,0.2c0.5,0.1,1,0.3,1.5,0.6V0.6c-0.5-0.2-1.1-0.4-1.7-0.5C158.7,0,158.1-0.1,157.4-0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M164.3,10.5v18h5.6V8.9h-4C165,8.9,164.3,9.6,164.3,10.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M170.1,1.6c-0.3-0.5-0.7-1-1.2-1.3c-0.5-0.3-1.1-0.5-1.7-0.5c-1.9,0-3.5,1.5-3.5,3.4c0,0,0,0,0,0.1 c0,0.6,0.2,1.2,0.5,1.8c0.3,0.5,0.7,1,1.3,1.3c0.5,0.3,1.1,0.5,1.8,0.5c0.6,0,1.2-0.2,1.7-0.5c0.5-0.3,1-0.7,1.2-1.3 c0.3-0.5,0.5-1.1,0.5-1.8C170.5,2.8,170.4,2.2,170.1,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M100.7,10.4v0.7c-0.6-0.7-1.2-1.3-2-1.8c-1.2-0.7-2.6-1-4.2-1c-1.8,0-3.5,0.5-5,1.4C88,10.7,86.8,12,86,13.5 c-0.8,1.6-1.3,3.4-1.2,5.2l0,0v0l0,0c0,1.8,0.4,3.6,1.2,5.2c0.8,1.5,2,2.8,3.4,3.8c1.5,1,3.3,1.4,5,1.4c1.6,0,3-0.3,4.2-1 c0.8-0.5,1.5-1.1,2-1.8v2.3h5.3V8.9h-3.7C101.4,8.9,100.7,9.6,100.7,10.4z M100.4,18.7L100.4,18.7c0,0.9-0.2,1.8-0.7,2.5 c-0.4,0.7-1,1.4-1.8,1.8c-0.8,0.5-1.7,0.7-2.6,0.7c-0.9,0-1.8-0.2-2.6-0.7c-1.5-0.9-2.5-2.6-2.4-4.4v0l0,0c0-0.9,0.2-1.8,0.7-2.5 c0.4-0.8,1-1.4,1.8-1.8c0.8-0.5,1.7-0.7,2.6-0.7c0.9,0,1.8,0.2,2.6,0.7c0.7,0.5,1.3,1.1,1.8,1.8C100.2,16.9,100.4,17.8,100.4,18.7 L100.4,18.7L100.4,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st1",
    d: "M28.4,23.5v5h-9.2c-1.3,0-2.6-0.5-3.5-1.4l-1.5-1.5v-5h11.2C27,20.5,28.4,21.8,28.4,23.5 C28.4,23.5,28.4,23.5,28.4,23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st2",
    d: "M14.2,20.5v5l-1.5,1.5c-0.9,0.9-2.2,1.4-3.5,1.4h-9.2v-5c0-1.7,1.3-3,3-3H14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st3",
    d: "M28.4,8.4V1.9l-12,8c-1.4,0.9-2.2,2.5-2.2,4.1v6.5l12-8C27.6,11.6,28.4,10,28.4,8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st4",
    d: "M14.2,14v6.5l-12-8C0.7,11.6-0.1,10-0.1,8.4V1.9l12,8C13.3,10.8,14.2,12.3,14.2,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kl_st0",
    d: "M172.1,25.8c0.7-0.7,1.8-0.7,2.4,0c0.7,0.7,0.7,1.8,0,2.4c-0.7,0.7-1.8,0.7-2.4,0c-0.3-0.3-0.5-0.8-0.5-1.2 C171.6,26.5,171.8,26.1,172.1,25.8z M173.3,28.4c0.4,0,0.7-0.1,1-0.4c0.5-0.5,0.5-1.4,0-2c-0.5-0.5-1.4-0.5-2,0 c-0.5,0.5-0.5,1.4,0,2C172.6,28.2,173,28.4,173.3,28.4z M174,26.7c0,0.2-0.1,0.4-0.3,0.5l0.4,0.6h-0.4l-0.3-0.6h-0.2v0.6h-0.4v-1.7 h0.6c0.2,0,0.3,0,0.5,0.2C173.9,26.4,174,26.5,174,26.7z M173.1,26.5v0.5h0.2c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2 c0-0.2-0.1-0.2-0.3-0.2L173.1,26.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoalafiLogo);
export default __webpack_public_path__ + "static/media/koalafi-logo.62ec9eea6860b1d30b08e8d17bc39447.svg";
export { ForwardRef as ReactComponent };